import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ApiHereService } from '../../services/api.here.service';
import { Mark } from '../../models/mark';

declare var H: any;
@Component({
  selector: 'one-core-map-here',
  templateUrl: './one-core-map-here.component.html',
  styleUrls: ['./one-core-map-here.component.scss']
})
export class OneCoreMapHereComponent implements AfterViewInit {
  @Output() onChangeMarker = new EventEmitter<any>();
  platform: any;
  map: any;
  @ViewChild('mapElement')
  mapElement: ElementRef;
  isClickonMark: any = false;
  tempMark: any;
  @Input() start: Mark;
  @Input() end: Mark;
  @Input() lat: any;
  @Input() lng: any;
  @Input() canCreate: any = false;
  @Input() public width: any = '100%';
  @Input() public height: any = '400px';
  marks: any = [];
  @Input() externalMarks: any = [];
  defaultIcon: any = '<svg width="24" height="24" aria-hidden="true" data-prefix="fas" data-icon="map-marker" class="svg-inline--fa fa-map-marker fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="${FILL}" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"></path></svg>';
  tooltip_top: any = '10px';
  tooltip_left: any = '10px';
  @Input() readOnly: boolean = false;
  constructor(private apiHereService: ApiHereService) {
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      this.platform = this.apiHereService.getPlataform();
      if (this.lat && this.lng) {
        this.createMap(this.lat, this.lng);
      } else
        if (this.start) {
          this.createMap(this.start.lat, this.start.lng);
        } else {
          navigator.geolocation.getCurrentPosition((position) => {
            this.createMap(position.coords.latitude, position.coords.longitude);
          }, () => {
            this.createMap(19.4326018, -99.13320490000001);
          });
        }
    }, 100);
  }

  setStartMarks(mark: Mark) {
    this.start = mark;
    if (this.map) {
      this.map.addObject(this.createMark(mark, 'blue'));
    }
  }
  setEndMarks(mark: Mark) {
    this.end = mark;
    if (this.map) {
      this.map.addObject(this.createMark(mark, 'blue'));
    }
  }

  createMap(latitude: number, longitude: number) {
    var pixelRatio = window.devicePixelRatio || 1;
    var defaultLayers = this.platform.createDefaultLayers({
      tileSize: pixelRatio === 1 ? 256 : 512,
      ppi: pixelRatio === 1 ? undefined : 320
    });
    this.map = new H.Map(
      this.mapElement.nativeElement,
      defaultLayers.normal.map,
      {
        pixelRatio: pixelRatio,
        zoom: 13,
        center: { lat: latitude, lng: longitude }
      }
    );
    
    this.map.addEventListener('tap', (evt) => {
      if (!this.readOnly) {
        setTimeout(() => {
          if (!this.isClickonMark) {
            let coords = this.map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
            if (this.tempMark) {
              this.setNewPositionMark(coords, this.tempMark);
            } else {
              if (this.canCreate) {
                this.createNewMark(coords, this.marks.length + 1);
              }
            }
          }
          this.isClickonMark = false;
        }, 100);
      }
    });
    new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
    H.ui.UI.createDefault(this.map, defaultLayers);
    if (this.start) {
      this.setStartMarks(this.start);
    }
    if (this.end) {
      this.setEndMarks(this.end);
    }
    if (this.map && this.map.paintRoute && (this.start || this.end)) {
      this.map.paintRoute();
    }
  }
  setNewPositionMark(coords: any, markEdit: any) {
    if (markEdit) {
      markEdit.setPosition({
        lat: coords.lat,
        lng: coords.lng
      });
      this.onChangeMarker.emit(markEdit);
    }
  }
  createMarks(marks: Mark[]) {
    marks.forEach((item) => {
      let mark = this.createByMark(item);
      this.marks.push(mark);
      this.map.addObject(mark);
    })
  }
  createByMark(mark: Mark) {
    return this.createMark(mark);
  }
  addSearchMarks(markObj: Mark) {
    let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'yellow'));
    let mark = new H.map.Marker(markObj, { icon: icon });
    mark.addEventListener('tap', (arg) => {
      if (!this.readOnly) {
        this.map.removeObject(arg.target);
        mark = undefined;
        arg.target = undefined;
      }
    }, true, this);
    this.map.addObject(mark);
  }
  clearMarks() {
    if (this.map) {
      let obs = this.map.getObjects();
      if (obs && obs.length) {
        this.map.removeObjects(obs);
      }
    }
  }
  createMark(markObj: Mark, color?: string) {
    let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', color ? color : 'blue'));
    let mark = new H.map.Marker(markObj, { icon: icon });
    mark.addEventListener('tap', (arg) => {
      if (!this.readOnly) {
        this.isClickonMark = true;
        let select = true;
        if (this.tempMark) {
          let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'blue'));
          this.tempMark.setIcon(icon);
          if (this.tempMark.getId() == arg.target.getId()) {
            select = false;
            this.tempMark = null;
          }
        }
        if (select) {
          this.tempMark = arg.target;
          let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'red'));
          this.tempMark.setIcon(icon);
        }
      }
    }, true, this);
    return mark;
  }

  createNewMark(coords: any, id: any) {
    let mark = this.createMark({
      lat: coords.lat,
      lng: coords.lng,
      data: coords,
      id: id
    });
    this.marks.push(mark);
    this.map.addObject(mark);
  }

  paintRoute() {
    this.apiHereService.paintRoute(this.marks, this.start, this.end, (result) => {
      let route,
        routeShape,
        startPoint,
        endPoint,
        linestring;
      if (result.response.route) {
        route = result.response.route[0];
        routeShape = route.shape;
        linestring = new H.geo.LineString();
        routeShape.forEach(function (point) {
          var parts = point.split(',');
          linestring.pushLatLngAlt(parts[0], parts[1]);
        });

        var routeLine = new H.map.Polyline(linestring, {
          style: { strokeColor: 'blue', lineWidth: 2 }
        });
        this.map.addObjects([routeLine]);
        this.map.setViewBounds(routeLine.getBounds());
      }
    });
  }

  getParametersForFinSequence() {
    return {
      'start': 'star;27.502181,-109.9616106',
      'destinations': ['dest1;27.4896918,-109.9370226', 'dest2;27.493965,-109.953956'],
      'end': 'end;27.502181,-109.9616106',
      'mode': 'fastest;car'
    };
  }

  calculateSequence() {
    let findSequenceService = this.apiHereService.getFindSequenceService();
    let calculateRouteParams = this.getParametersForFinSequence();
    findSequenceService.findSequence(calculateRouteParams, (response) => {
      this.marks.length = 0;
      response.results[0].waypoints.forEach((item) => {
        let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'blue'));
        let mark = new H.map.Marker({
          lat: item.lat,
          lng: item.lng,
          data: item,
          isDraggable: true,
          id: item.id
        }, { icon: icon });
        mark.addEventListener('tap', (arg) => {
          if (!this.readOnly) {
            this.isClickonMark = true;
            if (this.tempMark) {
              let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'blue'));
              this.tempMark.setIcon(icon);
              if (this.tempMark.getId() == arg.target.getId()) {
                this.tempMark = null;
              }
            }
            if (!this.tempMark || this.tempMark.getId() != arg.target.getId()) {
              this.tempMark = arg.target;
              let icon = new H.map.Icon(this.defaultIcon.replace('${FILL}', 'red'));
              this.tempMark.setIcon(icon);
            }
          }
        }, true, this);
        this.marks.push(mark);
      });
      this.map.addObjects(this.marks);

    }, (error) => {
      alert(error.message);
    });
  }

  setOrder(marks: Mark[]) {
    let toOrder = Object.assign([], marks);
    this.marks.length = 0;
    marks.forEach((item) => {
      this.marks.push(toOrder.find(i => i.id == item.id));
    });
  }

  setMapCenter(coords: any) {
    this.map.setCenter({ lat: coords.lat, lng: coords.lng });

  }
}
